module.exports = __webpack_public_path__ + "img/newsImg12-8.3c60457e.png";